









import IconBase from "@/common/components/atoms/IconBase.vue";
import IconRankingFirst from "@/common/components/icons/IconRankingFirst.vue";
import IconRankingSecond from "@/common/components/icons/IconRankingSecond.vue";
import IconRankingThird from "@/common/components/icons/IconRankingThird.vue";
import IconRankingOther from "@/common/components/icons/IconRankingOther.vue";
import { Prop, Component, Vue } from "vue-property-decorator";

@Component({
  components: {
    IconBase,
    IconRankingFirst,
    IconRankingSecond,
    IconRankingThird,
    IconRankingOther
  }
})
export default class G01IconRanking extends Vue {
  @Prop({ type: Number, required: true }) num!: number;

  get icon() {
    switch (this.num) {
      case 1:
        return "IconRankingFirst";
      case 2:
        return "IconRankingSecond";
      case 3:
        return "IconRankingThird";
      default:
        return "IconRankingOther";
    }
  }
  get isTop3() {
    return [1, 2, 3].includes(this.num);
  }
}
